import ProgramacionClass from "src/app/model/api/datos/programacionClass";
import Paging from "src/app/model/api/generic/paging";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class ProgramacionesTable extends DatabaseTable<ProgramacionClass> {

    public async getAll(): Promise<ProgramacionClass[]> {
        return await this.GetAllRecords()
    }

    public async getById(Id: number): Promise<ProgramacionClass> {
        let records = await this.GetRecordsById(0, 1, Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByAreaId(AreaId: number): Promise<ProgramacionClass> {
        let records = await this.GetRecordsByIndex(0, 1, 'AreaId', AreaId, AreaId)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getPaged(start: number, limit: number): Promise<Paging<ProgramacionClass>> {
        let count = await this.GetRecordsCount()
        let data = await this.GetRecordsPage(start, limit)

        let result = new Paging<ProgramacionClass>()
        result.page = Math.floor(start / limit) + 1
        result.total = count
        result.totalPages = Math.ceil(result.total / limit)
        result.collection = data
        result.count = data.length
        return result
    }

    public async update(record: ProgramacionClass): Promise<void> {
        await this.UpdateRecord(record)
    }

    public async delete(record: ProgramacionClass): Promise<void> {
        if (!record?.Id) return
        await this.DeleteRecord(record.Id)
    }

}